export default "__VITE_ASSET__5PfqbVrY__ 400w, __VITE_ASSET__XEyNRqPk__ 640w, __VITE_ASSET__CAT1Wr5i__ 900w";